const RX_ADVANCE_NOTIFICATION = [1, 2, 3, 4, 5, 6]; /* weeks */

type RX_ADVANCE_NOTIFICATION = typeof RX_ADVANCE_NOTIFICATION;

export default RX_ADVANCE_NOTIFICATION;
